import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import BrokerIntelligencePage from '@/pages/BrokerIntelligencePage';
import BrokerScorecardPage from '@/pages/BrokerScorecardPage';
import OnboardingPage from '@/pages/OnboardingPage';
import PanelGrowthPage from '@/pages/PanelGrowthPage';
import ConductTrendsPage from '@/pages/ConductTrendsPage';
import AffinityPartnersPage from '@/pages/AffinityPartnersPage';

export default function DistributionModule() {
  const tabs = [
    { id: 'leaderboard', label: 'Leaderboard', content: <BrokerScorecardPage /> },
    { id: 'brokers', label: 'Broker Intel', content: <BrokerIntelligencePage /> },
    { id: 'affinity', label: 'Affinity Partners', content: <AffinityPartnersPage /> },
    { id: 'conduct', label: 'Conduct Trends', content: <ConductTrendsPage /> },
    { id: 'growth', label: 'Panel Growth', content: <PanelGrowthPage /> },
    { id: 'onboarding', label: 'Onboarding', content: <OnboardingPage /> },
  ];

  return (
    <ModuleShell title="Distribution" subtitle="Broker, affinity and panel distribution" tabs={tabs} />
  );
}
